import React from "react"

class ModalHeader extends React.Component {
  constructor(props) {
    super(props)
  };

  componentDidMount() {
    this.setupCloseButton();
  };

  render() {
    return null
  };

  setupCloseButton() {
    var $defaultHeaderButton = $('.modal-header .close')

    if(typeof this.props.onClick == 'function') {
      (function (onClick) {
        var onClick = onClick.bind(this);
        $defaultHeaderButton.on('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          onClick(e)
        });
      })(this.props.onClick);
    }
  };

};

export default ModalHeader